export enum SessionStorageKey {
  // How a social sign up was started. Written when the user leaves for the
  // provider, read when the provider sends them back (OVP-3049).
  SocialSignUp = 'uvo__social_sign_up',
}
